import { render, staticRenderFns } from "./bindMobile.vue?vue&type=template&id=44b11470&scoped=true"
import script from "./bindMobile.vue?vue&type=script&lang=js"
export * from "./bindMobile.vue?vue&type=script&lang=js"
import style0 from "./bindMobile.vue?vue&type=style&index=0&id=44b11470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b11470",
  null
  
)

export default component.exports